"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _minesites = _interopRequireDefault(require("../minesites"));
var _viewusers = _interopRequireDefault(require("../viewusers"));
var _userdetails = _interopRequireDefault(require("../userdetails"));
var _inviteusers = _interopRequireDefault(require("../inviteusers"));
var _AddUserToSites = _interopRequireDefault(require("../AddUserToSites"));
var _manageYourTeam = require("../manageYourTeam.action");
var _mainModule = _interopRequireDefault(require("./main.module.css"));
class MainPage extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      manageStep: 0,
      minesiteModal: false,
      deleteModal: false,
      deleteUserData: '',
      deleteMineData: '',
      roleName: {
        appRoleObjectId: '',
        roleName: ''
      },
      selectedBusinessEntity: {},
      selectedUser: {}
    };
    this.manageStepNavigation = this.manageStepNavigation.bind(this);
    this.viewUsersCallback = this.viewUsersCallback.bind(this);
    this.userDetailsCallback = this.userDetailsCallback.bind(this);
    this.deleteModaltrigger = this.deleteModaltrigger.bind(this);
    this.deleteMineSite = this.deleteMineSite.bind(this);
    this.onDeleteAccess = this.onDeleteAccess.bind(this);
    this.addTeamMemberCallback = this.addTeamMemberCallback.bind(this);
    this.viewUsersAddTeamMemberCallback = this.viewUsersAddTeamMemberCallback.bind(this);
    this.deleteMineConf = this.deleteMineConf.bind(this);
  }

  /**
   * OnClick of View Users in Mine Sites
   */
  viewUsersCallback(item) {
    this.setState({
      selectedBusinessEntity: item
    });
    this.manageStepNavigation(1);
  }
  userDetailsCallback(data) {
    // this.props.getBusinessEntities(this.props.applicationID, this.props.sourceSystemName);
    this.props.getUserActivities(data, this.props.applicationID);
    this.setState({
      selectedUser: data
    });
    this.manageStepNavigation(2);
  }
  addUsersCallback() {}
  appinfo() {
    this.props.appinfo({
      appid: this.props.applicationID,
      srouceSystem: this.props.sourceSystemName
    });
  }
  componentDidMount() {
    this.appinfo();
    if (this.props !== undefined) {
      if (this.props.appName !== undefined) {
        window.localStorage.setItem('appName', this.props.appName);
      }
      if (this.props.applicationID !== undefined) {
        window.localStorage.setItem('appID', this.props.applicationID);
        this.props.getAssignableUsers(this.props.applicationID);
      }
    }
  }
  /*
   * Start:
   * Remove Access to the user on click of modal popup
   */
  onDeleteAccess() {
    this.props.updateRemoveAccessStatus(false);
    this.props.deleteUserAccess(this.props.applicationID, this.state.deleteUserData, this.state.selectedBusinessEntity);
    this.deleteModaltrigger();
  }
  addTeamMemberCallback() {
    this.manageStepNavigation(4);
  }
  viewUsersAddTeamMemberCallback() {
    this.manageStepNavigation(3);
  }
  deleteModaltrigger(item, e, index) {
    this.setState({
      deleteModal: !this.state.deleteModal,
      deleteUserData: item
    });
  }
  deleteMineSite(data) {
    this.setState({
      minesiteModal: !this.state.minesiteModal,
      deleteMineData: data
    });
  }
  deleteMineConf(appid, reqbody, selectedBusinessEntity) {
    this.props.deleteUserAccess(appid, reqbody, selectedBusinessEntity);
    this.setState({
      minesiteModal: !this.state.minesiteModal
    });
  }
  manageStepNavigation(stepName) {
    this.setState({
      manageStep: stepName
    });
  }
  renderMineSites() {
    return /*#__PURE__*/_react.default.createElement(_minesites.default, {
      viewUsersCallback: this.viewUsersCallback,
      applicationID: this.props.applicationID,
      sourceSystemName: this.props.sourceSystemName
    });
  }
  renderViewUsers() {
    return this.props.roles && this.state.selectedBusinessEntity && /*#__PURE__*/_react.default.createElement(_viewusers.default, {
      navCallback: this.manageStepNavigation,
      userDetailsCallback: this.userDetailsCallback,
      deleteUserData: this.state.deleteUserData,
      deleteModaltrigger: this.deleteModaltrigger,
      deleteModal: this.state.deleteModal,
      onDeleteAccess: this.onDeleteAccess,
      businessEntity: this.state.selectedBusinessEntity,
      assignedRoles: this.props.roles,
      viewUsersAddTeamMemberCallback: this.viewUsersAddTeamMemberCallback,
      applicationID: this.props.applicationID
    });
  }
  renderViewDetails() {
    return /*#__PURE__*/_react.default.createElement(_userdetails.default, {
      selectedUser: this.state.selectedUser,
      navCallback: this.manageStepNavigation,
      mineSites: this.props.mines,
      userActivityData: this.props.userActivityData,
      deleteModaltrigger: this.deleteModaltrigger,
      deleteUserData: this.state.deleteUserData,
      assignedRoles: this.props.roles,
      addTeamMemberCallback: this.addTeamMemberCallback,
      deleteMineSite: this.deleteMineSite,
      Modal: this.state.minesiteModal,
      deleteMineData: this.state.deleteMineData,
      deleteMineConf: this.deleteMineConf,
      selectedBusinessEntity: this.state.selectedBusinessEntity
    });
  }
  renderAddTeamMember() {
    return /*#__PURE__*/_react.default.createElement(_AddUserToSites.default, {
      selectedUser: this.state.selectedUser,
      navCallback: this.manageStepNavigation
    });
  }
  renderInviteUsers() {
    return /*#__PURE__*/_react.default.createElement(_inviteusers.default, {
      navCallback: this.manageStepNavigation,
      selectedUser: this.state.selectedUser,
      selectedBusinessEntity: this.state.selectedBusinessEntity
    });
  }
  render() {
    const {
      manageStep
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _mainModule.default.pageMargin
    }, manageStep === 0 ? this.renderMineSites() : manageStep === 1 ? this.renderViewUsers() : manageStep === 2 ? this.renderViewDetails() : manageStep === 3 ? this.renderInviteUsers() : manageStep === 4 ? this.renderAddTeamMember() : '');
  }
}
function mapDispatchToProps(dispatch) {
  return {
    deleteUserAccess: (applicationID, deleteUserDataObj, businessDataObj) => {
      dispatch((0, _manageYourTeam.deleteUserAccess)(applicationID, deleteUserDataObj, businessDataObj));
    },
    updateRemoveAccessStatus: data => {
      dispatch((0, _manageYourTeam.updateRemoveAccessStatus)(data));
    },
    getBusinessEntities: (applicationID, srcSystem) => {
      dispatch((0, _manageYourTeam.getBusinessEntities)(applicationID, srcSystem));
    },
    getUserActivities: (data, applicationID) => {
      dispatch((0, _manageYourTeam.getUserActivities)(data, applicationID));
    },
    appinfo: data => {
      dispatch((0, _manageYourTeam.appinfo)(data));
    },
    getAssignableUsers: appid => {
      dispatch((0, _manageYourTeam.getAssignableUsers)(appid));
    }
  };
}
const mapStateToProps = state => ({
  roles: state.manageYourTeam.roles,
  mines: state.manageYourTeam.mines,
  userActivityData: state.manageYourTeam.userActivityData
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MainPage);